@if (loadError) {
  <section class="link-status">
    <div class="status-card">
      <i class="fas fa-triangle-exclamation status-icon"></i>
      <h3>We couldn't open this link</h3>
      <p>Please check your connection and try again. If the problem continues, contact your project team.</p>
    </div>
  </section>
} @else if (notFound) {
  <section class="link-status">
    <div class="status-card">
      <i class="fas fa-link-slash status-icon"></i>
      <h3>This link is no longer available</h3>
      <p>The link is invalid or has expired. Please contact your project team if you still need access.</p>
    </div>
  </section>
}
